/**
 * Currency utilities
 *
 * Locale -> varsayilan para birimi. Global SaaS: hardcoded TRY DEGIL.
 * Tek kaynak (HomePage/TopluAnaliz inline-duplike + rapor fallback'leri buradan).
 * NOT: kur/donusum YOK - yalniz etiket icin varsayilan birim.
 */
export const getDefaultCurrency = (locale) => {
  switch (locale) {
    case 'tr': return 'TRY';
    case 'ar': return 'SAR';
    case 'fr':
    case 'de':
    case 'es': return 'EUR';
    default: return 'USD';
  }
};
